import React, { useRef, useState, useEffect } from "react";
import LogoGeosoftsolutions from "../assets/LogoGeosoftsolutions.png";
import { actualizarInvitacion, cerrarSesion } from "../service/apiService";
import { useNavigate, useLocation } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";

function ResponseInvitation() {
  //react-router-doom
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const option = queryParams.get("option");

  const [response, setResponse] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token && !option) navigate("/");
    else 
    {
      //cierra cualquier sesion abierta
      cerrarSesion();
      responderAInvitacion()
    };
  }, [token, option, navigate]);



  const responderAInvitacion = async () => {
    let response = await actualizarInvitacion({
      token: token,
      option: option,
    });

    setResponse(response.data);
    setLoading(false);

    if(response.result)
    {
      setTimeout(() => {
        navigate("/");
      }, [5000])   
    }
  };

  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <div className="min-h-[calc(82vh)] flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <div className="w-full rounded-lg shadow-xl md:mt-0 sm:max-w-md xl:p-0 bg-ceniza_light border-gray-700">
          <div className="p-6 space-y-4 md:space-y-4 sm:p-4">
            <img
              className="w-[220px] h-auto mx-auto"
              src={LogoGeosoftsolutions}
              alt="logo"
            />

            <div className="border-gray-700 rounded-lg shadow-lg p-5">
              {loading && (
                <div>
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                </div>
              )}
              {!loading && (
                <p
                  className="mb-5 text-[18px]  leading-tight tracking-tight text-blanco text-center"
                  style={{ letterSpacing: "2px" }}
                >
                  {response}
                </p>
              )}
            </div>
            <br />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResponseInvitation;
